define('presentation/shell/viewModels/interiorExtendedShellViewModel',[
    'businessServices/events/eventManager',
    'businessServices/router/router',
    'common/promises/promiseFactory',
    'constants/shellNameEnumerations',
    'settings/navigationConfiguration'
], function () {
    return function () {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _eventManager = require('businessServices/events/eventManager');
        const _navigationConfig = require('settings/navigationConfiguration');
        const _shellNameEnumerations = require('constants/shellNameEnumerations');

        const _onShellUpdated = (shellName) => {
            if (shellName === _shellNameEnumerations.interiorExtended) {
                self.shellIsActive(true);
                if (self.router.activeItem() === null) {
                    self.contentPane(null);
                }
            } else {
                self.shellIsActive(false);
            }
        };

        const _setCssRootClass = () => {
            let cssRootClass = self.router.activeInstruction().config.customSettings.cssRootClass;
            if (cssRootClass === undefined || cssRootClass === null) {
                self.cssRootClass("");
            } else {
                self.cssRootClass(cssRootClass);
            }
        };

        const _onActiveItemChange = (activeItem) => {
            _setCssRootClass();

            if ((activeItem.parentViewModel) && (ko.isObservable(activeItem.parentViewModel))) {
                activeItem.parentViewModel(self);
            } else {
                activeItem.parentViewModel = self;
            }

            self.contentViewModel(activeItem);
        };

        self.router = null;
        self.homepageURL = "";
        self.shellIsActive = ko.observable(true);
        self.cssRootClass = ko.observable("");
        self.contentViewModel = ko.observable(null);

        self.activate = () => {
            self.router = require('businessServices/router/router');

            return _initialize();
        };

        const _initialize = () => {
            _setCssRootClass();

            self.homepageURL = _navigationConfig.homePageUrl;
            let activeItem = self.router.activeItem();

            if ((activeItem.parentViewModel) && (ko.isObservable(activeItem.parentViewModel))) {
                activeItem.parentViewModel(self);
            } else {
                activeItem.parentViewModel = self;
            }

            self.contentViewModel(activeItem);
            _eventManager.subscribeShellUpdated(_onShellUpdated);
            self.router.activeItem.subscribe(_onActiveItemChange);

            return _promiseFactory.wait();
        };
    };
});
